module.exports = __webpack_public_path__ + "img/REC_ENFANT_FEMME_DESACTIVE.9b2d15ce.svg";